/**
 * Study Attachment Service
 */

import { api } from '../../lib/api'
import { API_ROUTES } from '../../config/constants'
import type {
  StudyAttachment,
  CreateAttachmentData,
  AttachmentUploadResult,
} from '../../domain/attachment/types'

export const attachmentService = {
  /**
   * List attachments for a study
   */
  list: async (studyId: string): Promise<{ attachments: StudyAttachment[] }> => {
    const response = await api.get(API_ROUTES.ATTACHMENTS.LIST(studyId))
    return response.data
  },

  /**
   * Get attachment count for a study
   */
  count: async (studyId: string): Promise<{ count: number }> => {
    const response = await api.get(API_ROUTES.ATTACHMENTS.COUNT(studyId))
    return response.data
  },

  /**
   * Upload attachment
   */
  upload: async (
    studyId: string,
    data: CreateAttachmentData
  ): Promise<AttachmentUploadResult> => {
    const response = await api.post(API_ROUTES.ATTACHMENTS.UPLOAD(studyId), data)
    return response.data
  },

  /**
   * Download attachment
   */
  download: async (studyId: string, attachmentId: string): Promise<Blob> => {
    const response = await api.get(
      API_ROUTES.ATTACHMENTS.DOWNLOAD(studyId, attachmentId),
      {
        responseType: 'blob',
      }
    )
    return response.data
  },

  /** Pide al motor el texto de un dictado grabado. No lo guarda. */
  transcribir: async (studyId: string, attachmentId: string): Promise<{ text: string }> => {
    const response = await api.post(API_ROUTES.ATTACHMENTS.TRANSCRIBIR(studyId, attachmentId))
    return response.data
  },

  /**
   * Delete attachment
   * Using POST instead of DELETE for WAF compatibility
   */
  delete: async (studyId: string, attachmentId: string): Promise<void> => {
    await api.post(API_ROUTES.ATTACHMENTS.DELETE(studyId, attachmentId))
  },
}
